// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1mQj7","header":"ReportDetails_header__Eblig","title":"ReportDetails_title__a3Jbr","left":"ReportDetails_left__2CNFb"};